import './MyContentUploadModal.css';
import { NebulaIcon as Ce } from "@discoveryedu/nebula-components";
import Ee from "axios";
import { defineComponent as Se, ref as De, computed as Oe, onMounted as Ie, watch as Ae, onUnmounted as Re, Comment as Me, cloneVNode as Pe, openBlock as k, createElementBlock as N, createElementVNode as c, normalizeClass as S, renderSlot as ce, withDirectives as Ue, vShow as Le, resolveComponent as Q, createVNode as I, withCtx as j, toDisplayString as g, createTextVNode as de, Fragment as $, renderList as X, createCommentVNode as xe } from "vue";
import { g as Be, a as Ke } from "./platform-components-assets/myContentApi-es.js";
import { _ as he } from "./platform-components-assets/_plugin-vue_export-helper-es.js";
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var ye = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], z = /* @__PURE__ */ ye.join(","), ge = typeof Element > "u", R = ge ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, V = !ge && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t == null ? void 0 : t.ownerDocument;
}, G = function t(e, a) {
  var o;
  a === void 0 && (a = !0);
  var r = e == null || (o = e.getAttribute) === null || o === void 0 ? void 0 : o.call(e, "inert"), i = r === "" || r === "true", n = i || a && e && t(e.parentNode);
  return n;
}, je = function(e) {
  var a, o = e == null || (a = e.getAttribute) === null || a === void 0 ? void 0 : a.call(e, "contenteditable");
  return o === "" || o === "true";
}, we = function(e, a, o) {
  if (G(e))
    return [];
  var r = Array.prototype.slice.apply(e.querySelectorAll(z));
  return a && R.call(e, z) && r.unshift(e), r = r.filter(o), r;
}, _e = function t(e, a, o) {
  for (var r = [], i = Array.from(e); i.length; ) {
    var n = i.shift();
    if (!G(n, !1))
      if (n.tagName === "SLOT") {
        var f = n.assignedElements(), b = f.length ? f : n.children, u = t(b, !0, o);
        o.flatten ? r.push.apply(r, u) : r.push({
          scopeParent: n,
          candidates: u
        });
      } else {
        var w = R.call(n, z);
        w && o.filter(n) && (a || !e.includes(n)) && r.push(n);
        var F = n.shadowRoot || // check for an undisclosed shadow
        typeof o.getShadowRoot == "function" && o.getShadowRoot(n), D = !G(F, !1) && (!o.shadowRootFilter || o.shadowRootFilter(n));
        if (F && D) {
          var C = t(F === !0 ? n.children : F.children, !0, o);
          o.flatten ? r.push.apply(r, C) : r.push({
            scopeParent: n,
            candidates: C
          });
        } else
          i.unshift.apply(i, n.children);
      }
  }
  return r;
}, Fe = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, A = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || je(e)) && !Fe(e) ? 0 : e.tabIndex;
}, $e = function(e, a) {
  var o = A(e);
  return o < 0 && a && !Fe(e) ? 0 : o;
}, qe = function(e, a) {
  return e.tabIndex === a.tabIndex ? e.documentOrder - a.documentOrder : e.tabIndex - a.tabIndex;
}, Te = function(e) {
  return e.tagName === "INPUT";
}, ze = function(e) {
  return Te(e) && e.type === "hidden";
}, Ve = function(e) {
  var a = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(o) {
    return o.tagName === "SUMMARY";
  });
  return a;
}, Ge = function(e, a) {
  for (var o = 0; o < e.length; o++)
    if (e[o].checked && e[o].form === a)
      return e[o];
}, He = function(e) {
  if (!e.name)
    return !0;
  var a = e.form || V(e), o = function(f) {
    return a.querySelectorAll('input[type="radio"][name="' + f + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = o(window.CSS.escape(e.name));
  else
    try {
      r = o(e.name);
    } catch (n) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", n.message), !1;
    }
  var i = Ge(r, e.form);
  return !i || i === e;
}, We = function(e) {
  return Te(e) && e.type === "radio";
}, Ye = function(e) {
  return We(e) && !He(e);
}, Ze = function(e) {
  var a, o = e && V(e), r = (a = o) === null || a === void 0 ? void 0 : a.host, i = !1;
  if (o && o !== e) {
    var n, f, b;
    for (i = !!((n = r) !== null && n !== void 0 && (f = n.ownerDocument) !== null && f !== void 0 && f.contains(r) || e != null && (b = e.ownerDocument) !== null && b !== void 0 && b.contains(e)); !i && r; ) {
      var u, w, F;
      o = V(r), r = (u = o) === null || u === void 0 ? void 0 : u.host, i = !!((w = r) !== null && w !== void 0 && (F = w.ownerDocument) !== null && F !== void 0 && F.contains(r));
    }
  }
  return i;
}, ue = function(e) {
  var a = e.getBoundingClientRect(), o = a.width, r = a.height;
  return o === 0 && r === 0;
}, Qe = function(e, a) {
  var o = a.displayCheck, r = a.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var i = R.call(e, "details>summary:first-of-type"), n = i ? e.parentElement : e;
  if (R.call(n, "details:not([open]) *"))
    return !0;
  if (!o || o === "full" || o === "legacy-full") {
    if (typeof r == "function") {
      for (var f = e; e; ) {
        var b = e.parentElement, u = V(e);
        if (b && !b.shadowRoot && r(b) === !0)
          return ue(e);
        e.assignedSlot ? e = e.assignedSlot : !b && u !== e.ownerDocument ? e = u.host : e = b;
      }
      e = f;
    }
    if (Ze(e))
      return !e.getClientRects().length;
    if (o !== "legacy-full")
      return !0;
  } else if (o === "non-zero-area")
    return ue(e);
  return !1;
}, Xe = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var a = e.parentElement; a; ) {
      if (a.tagName === "FIELDSET" && a.disabled) {
        for (var o = 0; o < a.children.length; o++) {
          var r = a.children.item(o);
          if (r.tagName === "LEGEND")
            return R.call(a, "fieldset[disabled] *") ? !0 : !r.contains(e);
        }
        return !0;
      }
      a = a.parentElement;
    }
  return !1;
}, H = function(e, a) {
  return !(a.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  G(a) || ze(a) || Qe(a, e) || // For a details element with a summary, the summary element gets the focus
  Ve(a) || Xe(a));
}, ee = function(e, a) {
  return !(Ye(a) || A(a) < 0 || !H(e, a));
}, Je = function(e) {
  var a = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(a) || a >= 0);
}, et = function t(e) {
  var a = [], o = [];
  return e.forEach(function(r, i) {
    var n = !!r.scopeParent, f = n ? r.scopeParent : r, b = $e(f, n), u = n ? t(r.candidates) : f;
    b === 0 ? n ? a.push.apply(a, u) : a.push(f) : o.push({
      documentOrder: i,
      tabIndex: b,
      item: r,
      isScope: n,
      content: u
    });
  }), o.sort(qe).reduce(function(r, i) {
    return i.isScope ? r.push.apply(r, i.content) : r.push(i.content), r;
  }, []).concat(a);
}, tt = function(e, a) {
  a = a || {};
  var o;
  return a.getShadowRoot ? o = _e([e], a.includeContainer, {
    filter: ee.bind(null, a),
    flatten: !1,
    getShadowRoot: a.getShadowRoot,
    shadowRootFilter: Je
  }) : o = we(e, a.includeContainer, ee.bind(null, a)), et(o);
}, at = function(e, a) {
  a = a || {};
  var o;
  return a.getShadowRoot ? o = _e([e], a.includeContainer, {
    filter: H.bind(null, a),
    flatten: !0,
    getShadowRoot: a.getShadowRoot
  }) : o = we(e, a.includeContainer, H.bind(null, a)), o;
}, M = function(e, a) {
  if (a = a || {}, !e)
    throw new Error("No node provided");
  return R.call(e, z) === !1 ? !1 : ee(a, e);
}, ot = /* @__PURE__ */ ye.concat("iframe").join(","), J = function(e, a) {
  if (a = a || {}, !e)
    throw new Error("No node provided");
  return R.call(e, ot) === !1 ? !1 : H(a, e);
};
/*!
* focus-trap 7.5.2
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function fe(t, e) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), a.push.apply(a, o);
  }
  return a;
}
function be(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = arguments[e] != null ? arguments[e] : {};
    e % 2 ? fe(Object(a), !0).forEach(function(o) {
      nt(t, o, a[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : fe(Object(a)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(a, o));
    });
  }
  return t;
}
function nt(t, e, a) {
  return e = it(e), e in t ? Object.defineProperty(t, e, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = a, t;
}
function rt(t, e) {
  if (typeof t != "object" || t === null) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var o = a.call(t, e || "default");
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function it(t) {
  var e = rt(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
var pe = {
  activateTrap: function(e, a) {
    if (e.length > 0) {
      var o = e[e.length - 1];
      o !== a && o.pause();
    }
    var r = e.indexOf(a);
    r === -1 || e.splice(r, 1), e.push(a);
  },
  deactivateTrap: function(e, a) {
    var o = e.indexOf(a);
    o !== -1 && e.splice(o, 1), e.length > 0 && e[e.length - 1].unpause();
  }
}, st = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, lt = function(e) {
  return (e == null ? void 0 : e.key) === "Escape" || (e == null ? void 0 : e.key) === "Esc" || (e == null ? void 0 : e.keyCode) === 27;
}, B = function(e) {
  return (e == null ? void 0 : e.key) === "Tab" || (e == null ? void 0 : e.keyCode) === 9;
}, ct = function(e) {
  return B(e) && !e.shiftKey;
}, dt = function(e) {
  return B(e) && e.shiftKey;
}, ve = function(e) {
  return setTimeout(e, 0);
}, me = function(e, a) {
  var o = -1;
  return e.every(function(r, i) {
    return a(r) ? (o = i, !1) : !0;
  }), o;
}, x = function(e) {
  for (var a = arguments.length, o = new Array(a > 1 ? a - 1 : 0), r = 1; r < a; r++)
    o[r - 1] = arguments[r];
  return typeof e == "function" ? e.apply(void 0, o) : e;
}, q = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, ut = [], ft = function(e, a) {
  var o = (a == null ? void 0 : a.document) || document, r = (a == null ? void 0 : a.trapStack) || ut, i = be({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: ct,
    isKeyBackward: dt
  }, a), n = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, f, b = function(s, l, d) {
    return s && s[l] !== void 0 ? s[l] : i[d || l];
  }, u = function(s, l) {
    var d = typeof (l == null ? void 0 : l.composedPath) == "function" ? l.composedPath() : void 0;
    return n.containerGroups.findIndex(function(p) {
      var v = p.container, h = p.tabbableNodes;
      return v.contains(s) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (d == null ? void 0 : d.includes(v)) || h.find(function(y) {
        return y === s;
      });
    });
  }, w = function(s) {
    var l = i[s];
    if (typeof l == "function") {
      for (var d = arguments.length, p = new Array(d > 1 ? d - 1 : 0), v = 1; v < d; v++)
        p[v - 1] = arguments[v];
      l = l.apply(void 0, p);
    }
    if (l === !0 && (l = void 0), !l) {
      if (l === void 0 || l === !1)
        return l;
      throw new Error("`".concat(s, "` was specified but was not a node, or did not return a node"));
    }
    var h = l;
    if (typeof l == "string" && (h = o.querySelector(l), !h))
      throw new Error("`".concat(s, "` as selector refers to no known node"));
    return h;
  }, F = function() {
    var s = w("initialFocus");
    if (s === !1)
      return !1;
    if (s === void 0 || !J(s, i.tabbableOptions))
      if (u(o.activeElement) >= 0)
        s = o.activeElement;
      else {
        var l = n.tabbableGroups[0], d = l && l.firstTabbableNode;
        s = d || w("fallbackFocus");
      }
    if (!s)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return s;
  }, D = function() {
    if (n.containerGroups = n.containers.map(function(s) {
      var l = tt(s, i.tabbableOptions), d = at(s, i.tabbableOptions), p = l.length > 0 ? l[0] : void 0, v = l.length > 0 ? l[l.length - 1] : void 0, h = d.find(function(_) {
        return M(_);
      }), y = d.slice().reverse().find(function(_) {
        return M(_);
      }), T = !!l.find(function(_) {
        return A(_) > 0;
      });
      return {
        container: s,
        tabbableNodes: l,
        focusableNodes: d,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: T,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: p,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: v,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: h,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: y,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(O) {
          var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, E = l.indexOf(O);
          return E < 0 ? U ? d.slice(d.indexOf(O) + 1).find(function(L) {
            return M(L);
          }) : d.slice(0, d.indexOf(O)).reverse().find(function(L) {
            return M(L);
          }) : l[E + (U ? 1 : -1)];
        }
      };
    }), n.tabbableGroups = n.containerGroups.filter(function(s) {
      return s.tabbableNodes.length > 0;
    }), n.tabbableGroups.length <= 0 && !w("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (n.containerGroups.find(function(s) {
      return s.posTabIndexesFound;
    }) && n.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, C = function m(s) {
    if (s !== !1 && s !== o.activeElement) {
      if (!s || !s.focus) {
        m(F());
        return;
      }
      s.focus({
        preventScroll: !!i.preventScroll
      }), n.mostRecentlyFocusedNode = s, st(s) && s.select();
    }
  }, te = function(s) {
    var l = w("setReturnFocus", s);
    return l || (l === !1 ? !1 : s);
  }, ae = function(s) {
    var l = s.target, d = s.event, p = s.isBackward, v = p === void 0 ? !1 : p;
    l = l || q(d), D();
    var h = null;
    if (n.tabbableGroups.length > 0) {
      var y = u(l, d), T = y >= 0 ? n.containerGroups[y] : void 0;
      if (y < 0)
        v ? h = n.tabbableGroups[n.tabbableGroups.length - 1].lastTabbableNode : h = n.tabbableGroups[0].firstTabbableNode;
      else if (v) {
        var _ = me(n.tabbableGroups, function(Y) {
          var Z = Y.firstTabbableNode;
          return l === Z;
        });
        if (_ < 0 && (T.container === l || J(l, i.tabbableOptions) && !M(l, i.tabbableOptions) && !T.nextTabbableNode(l, !1)) && (_ = y), _ >= 0) {
          var O = _ === 0 ? n.tabbableGroups.length - 1 : _ - 1, U = n.tabbableGroups[O];
          h = A(l) >= 0 ? U.lastTabbableNode : U.lastDomTabbableNode;
        } else B(d) || (h = T.nextTabbableNode(l, !1));
      } else {
        var E = me(n.tabbableGroups, function(Y) {
          var Z = Y.lastTabbableNode;
          return l === Z;
        });
        if (E < 0 && (T.container === l || J(l, i.tabbableOptions) && !M(l, i.tabbableOptions) && !T.nextTabbableNode(l)) && (E = y), E >= 0) {
          var L = E === n.tabbableGroups.length - 1 ? 0 : E + 1, le = n.tabbableGroups[L];
          h = A(l) >= 0 ? le.firstTabbableNode : le.firstDomTabbableNode;
        } else B(d) || (h = T.nextTabbableNode(l));
      }
    } else
      h = w("fallbackFocus");
    return h;
  }, K = function(s) {
    var l = q(s);
    if (!(u(l, s) >= 0)) {
      if (x(i.clickOutsideDeactivates, s)) {
        f.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      x(i.allowOutsideClick, s) || s.preventDefault();
    }
  }, oe = function(s) {
    var l = q(s), d = u(l, s) >= 0;
    if (d || l instanceof Document)
      d && (n.mostRecentlyFocusedNode = l);
    else {
      s.stopImmediatePropagation();
      var p, v = !0;
      if (n.mostRecentlyFocusedNode)
        if (A(n.mostRecentlyFocusedNode) > 0) {
          var h = u(n.mostRecentlyFocusedNode), y = n.containerGroups[h].tabbableNodes;
          if (y.length > 0) {
            var T = y.findIndex(function(_) {
              return _ === n.mostRecentlyFocusedNode;
            });
            T >= 0 && (i.isKeyForward(n.recentNavEvent) ? T + 1 < y.length && (p = y[T + 1], v = !1) : T - 1 >= 0 && (p = y[T - 1], v = !1));
          }
        } else
          n.containerGroups.some(function(_) {
            return _.tabbableNodes.some(function(O) {
              return A(O) > 0;
            });
          }) || (v = !1);
      else
        v = !1;
      v && (p = ae({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: n.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(n.recentNavEvent)
      })), C(p || n.mostRecentlyFocusedNode || F());
    }
    n.recentNavEvent = void 0;
  }, ke = function(s) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    n.recentNavEvent = s;
    var d = ae({
      event: s,
      isBackward: l
    });
    d && (B(s) && s.preventDefault(), C(d));
  }, ne = function(s) {
    if (lt(s) && x(i.escapeDeactivates, s) !== !1) {
      s.preventDefault(), f.deactivate();
      return;
    }
    (i.isKeyForward(s) || i.isKeyBackward(s)) && ke(s, i.isKeyBackward(s));
  }, re = function(s) {
    var l = q(s);
    u(l, s) >= 0 || x(i.clickOutsideDeactivates, s) || x(i.allowOutsideClick, s) || (s.preventDefault(), s.stopImmediatePropagation());
  }, ie = function() {
    if (n.active)
      return pe.activateTrap(r, f), n.delayInitialFocusTimer = i.delayInitialFocus ? ve(function() {
        C(F());
      }) : C(F()), o.addEventListener("focusin", oe, !0), o.addEventListener("mousedown", K, {
        capture: !0,
        passive: !1
      }), o.addEventListener("touchstart", K, {
        capture: !0,
        passive: !1
      }), o.addEventListener("click", re, {
        capture: !0,
        passive: !1
      }), o.addEventListener("keydown", ne, {
        capture: !0,
        passive: !1
      }), f;
  }, se = function() {
    if (n.active)
      return o.removeEventListener("focusin", oe, !0), o.removeEventListener("mousedown", K, !0), o.removeEventListener("touchstart", K, !0), o.removeEventListener("click", re, !0), o.removeEventListener("keydown", ne, !0), f;
  }, Ne = function(s) {
    var l = s.some(function(d) {
      var p = Array.from(d.removedNodes);
      return p.some(function(v) {
        return v === n.mostRecentlyFocusedNode;
      });
    });
    l && C(F());
  }, W = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(Ne) : void 0, P = function() {
    W && (W.disconnect(), n.active && !n.paused && n.containers.map(function(s) {
      W.observe(s, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return f = {
    get active() {
      return n.active;
    },
    get paused() {
      return n.paused;
    },
    activate: function(s) {
      if (n.active)
        return this;
      var l = b(s, "onActivate"), d = b(s, "onPostActivate"), p = b(s, "checkCanFocusTrap");
      p || D(), n.active = !0, n.paused = !1, n.nodeFocusedBeforeActivation = o.activeElement, l == null || l();
      var v = function() {
        p && D(), ie(), P(), d == null || d();
      };
      return p ? (p(n.containers.concat()).then(v, v), this) : (v(), this);
    },
    deactivate: function(s) {
      if (!n.active)
        return this;
      var l = be({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, s);
      clearTimeout(n.delayInitialFocusTimer), n.delayInitialFocusTimer = void 0, se(), n.active = !1, n.paused = !1, P(), pe.deactivateTrap(r, f);
      var d = b(l, "onDeactivate"), p = b(l, "onPostDeactivate"), v = b(l, "checkCanReturnFocus"), h = b(l, "returnFocus", "returnFocusOnDeactivate");
      d == null || d();
      var y = function() {
        ve(function() {
          h && C(te(n.nodeFocusedBeforeActivation)), p == null || p();
        });
      };
      return h && v ? (v(te(n.nodeFocusedBeforeActivation)).then(y, y), this) : (y(), this);
    },
    pause: function(s) {
      if (n.paused || !n.active)
        return this;
      var l = b(s, "onPause"), d = b(s, "onPostPause");
      return n.paused = !0, l == null || l(), se(), P(), d == null || d(), this;
    },
    unpause: function(s) {
      if (!n.paused || !n.active)
        return this;
      var l = b(s, "onUnpause"), d = b(s, "onPostUnpause");
      return n.paused = !1, l == null || l(), D(), ie(), P(), d == null || d(), this;
    },
    updateContainerElements: function(s) {
      var l = [].concat(s).filter(Boolean);
      return n.containers = l.map(function(d) {
        return typeof d == "string" ? o.querySelector(d) : d;
      }), n.active && D(), P(), this;
    }
  }, f.updateContainerElements(e), f;
};
/*!
  * focus-trap-vue v4.0.1
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
const bt = {
  escapeDeactivates: {
    type: Boolean,
    default: !0
  },
  returnFocusOnDeactivate: {
    type: Boolean,
    default: !0
  },
  allowOutsideClick: {
    type: [Boolean, Function],
    default: !0
  },
  clickOutsideDeactivates: [Boolean, Function],
  initialFocus: [String, Function, Boolean],
  fallbackFocus: [String, Function],
  checkCanFocusTrap: Function,
  checkCanReturnFocus: Function,
  delayInitialFocus: {
    type: Boolean,
    default: !0
  },
  document: Object,
  preventScroll: Boolean,
  setReturnFocus: [Object, String, Boolean, Function],
  tabbableOptions: Object
}, pt = Se({
  props: Object.assign({
    active: {
      // TODO: could be options for activate but what about the options for deactivating?
      type: Boolean,
      default: !0
    }
  }, bt),
  emits: [
    "update:active",
    "activate",
    "postActivate",
    "deactivate",
    "postDeactivate"
  ],
  render() {
    return this.renderImpl();
  },
  setup(t, { slots: e, emit: a }) {
    let o;
    const r = De(null), i = Oe(() => {
      const f = r.value;
      return f && (f instanceof HTMLElement ? f : f.$el);
    });
    function n() {
      return o || (o = ft(i.value, {
        escapeDeactivates: t.escapeDeactivates,
        allowOutsideClick: t.allowOutsideClick,
        returnFocusOnDeactivate: t.returnFocusOnDeactivate,
        clickOutsideDeactivates: t.clickOutsideDeactivates,
        onActivate: () => {
          a("update:active", !0), a("activate");
        },
        onDeactivate: () => {
          a("update:active", !1), a("deactivate");
        },
        onPostActivate: () => a("postActivate"),
        onPostDeactivate: () => a("postDeactivate"),
        initialFocus: t.initialFocus,
        fallbackFocus: t.fallbackFocus,
        tabbableOptions: t.tabbableOptions,
        delayInitialFocus: t.delayInitialFocus
      }));
    }
    return Ie(() => {
      Ae(() => t.active, (f) => {
        f && i.value ? n().activate() : o && (o.deactivate(), (!i.value || i.value.nodeType === Node.COMMENT_NODE) && (o = null));
      }, { immediate: !0, flush: "post" });
    }), Re(() => {
      o && o.deactivate(), o = null;
    }), {
      activate() {
        n().activate();
      },
      deactivate() {
        o && o.deactivate();
      },
      renderImpl() {
        if (!e.default)
          return null;
        const f = e.default().filter((u) => u.type !== Me);
        return !f || !f.length || f.length > 1 ? (console.error("[focus-trap-vue]: FocusTrap requires exactly one child."), f) : Pe(f[0], { ref: r });
      }
    };
  }
}), vt = {
  emits: ["dropdownOpen"],
  data() {
    return {
      dropdownOpen: !1,
      localItems: this.items
    };
  },
  computed: {
    buttonClassName() {
      return [
        {
          "comet-dropdown-trigger--menu-visible": this.dropdownOpen,
          "comet-button--active comet-button--hover": this.dropdownOpen
        },
        "comet-button",
        "comet-dropdown-trigger",
        "js-comet-dropdown-trigger"
      ].concat(this.buttonClass);
    },
    arialLabelText() {
      return this.ariaLabel;
    },
    dropdownClassName() {
      return [
        {
          visible: this.dropdownOpen
        },
        this.dropdownClass
      ];
    }
  },
  methods: {
    closeDropdown() {
      this.dropdownOpen = !1, this.$emit("dropdownOpen", this.dropdownOpen);
    },
    onBodyClick({ target: t }) {
      t.closest(".modal-container") !== null && !this.isInModal || this.$el.contains(t) || this.closeDropdown();
    },
    openDropdown() {
      this.dropdownOpen = !0;
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen, this.$emit("dropdownOpen", this.dropdownOpen);
    },
    async handleClick() {
      this.customClick && await this.customClick(), this.toggleDropdown();
    },
    checkTabOrArrowKey(t) {
      if (this.checkArrowKey(t), t.keyCode === 9) {
        const e = this.getFocusable(), a = Array.prototype.indexOf.call(e, document.activeElement);
        t.shiftKey && a === 0 ? this.closeDropdown() : !t.shiftKey && a === e.length - 1 && this.closeDropdown();
      }
    },
    checkArrowKey(t) {
      t.keyCode === 38 ? (t.preventDefault(), this.selectNextUp(t)) : t.keyCode === 40 && (t.preventDefault(), this.selectNextDown(t));
    },
    selectNextUp() {
      const t = this.getFocusable(), e = Array.prototype.indexOf.call(t, document.activeElement);
      e > 0 ? t[e - 1].focus() : t[t.length - 1].focus();
    },
    selectNextDown() {
      const t = this.getFocusable(), e = Array.prototype.indexOf.call(t, document.activeElement);
      e < t.length - 1 ? t[e + 1].focus() : t[0].focus();
    },
    getFocusable() {
      return this.$refs.dropdownItems.querySelectorAll('button:not([tabindex="-1"]), [href]:not([tabindex="-1"])');
    }
  },
  props: {
    items: {
      default() {
        return [];
      },
      type: Array
    },
    id: {
      required: !1,
      type: String
    },
    ariaLabel: {
      required: !1,
      type: String
    },
    buttonClass: {
      required: !1,
      type: String
    },
    buttonId: {
      required: !0,
      type: String
    },
    dropdownClass: {
      required: !1,
      type: String
    },
    customClick: {
      required: !1,
      type: Function
    },
    isInModal: {
      default: !1,
      required: !1,
      type: Boolean
    }
  },
  mounted() {
    document.addEventListener("click", this.onBodyClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.onBodyClick);
  }
}, mt = {
  name: "CometDropdown",
  mixins: [vt],
  props: {
    buttonDisabled: {
      type: Boolean,
      default: !1
    }
  }
}, ht = { class: "comet-dropdown" }, yt = ["id", "aria-label", "disabled"], gt = ["aria-hidden", "aria-labelledby"];
function wt(t, e, a, o, r, i) {
  return k(), N("div", ht, [
    c("button", {
      id: t.buttonId,
      class: S(t.buttonClassName),
      "aria-label": t.arialLabelText,
      haspopup: "true",
      onClick: e[0] || (e[0] = (...n) => t.handleClick && t.handleClick(...n)),
      onKeydown: e[1] || (e[1] = (...n) => t.checkArrowKey && t.checkArrowKey(...n)),
      disabled: a.buttonDisabled
    }, [
      ce(t.$slots, "button")
    ], 42, yt),
    Ue(c("div", {
      class: S(["comet-dropdown-menu comet-popover", t.dropdownClassName]),
      "aria-hidden": !t.dropdownOpen,
      "aria-labelledby": t.buttonId,
      onKeydown: e[2] || (e[2] = (...n) => t.checkTabOrArrowKey && t.checkTabOrArrowKey(...n)),
      ref: "dropdownItems"
    }, [
      ce(t.$slots, "items", { closeDropdown: t.closeDropdown })
    ], 42, gt), [
      [Le, t.dropdownOpen]
    ])
  ]);
}
const _t = /* @__PURE__ */ he(mt, [["render", wt]]), Ft = {
  name: "MyContentUploadModal",
  components: {
    CometDropdown: _t,
    FocusTrap: pt,
    NebulaIcon: Ce
  },
  props: {
    options: {
      required: !0,
      type: Object,
      // Allow uploading multiple files at once
      allowMultiple: Boolean,
      // Base url for api requests
      baseURL: String,
      // Folder to upload to
      folderGuid: String,
      // Token used in the getUploadUrlApi request
      uploadToken: String,
      // Files to add to the modal immediately
      initFiles: Array
    }
  },
  emits: [
    "assetsUploaded",
    "closeModal"
  ],
  data() {
    return {
      headers: [
        {
          type: "file-name",
          label: this.$t("Filename")
        },
        {
          type: "size",
          label: this.$t("Size")
        },
        {
          type: "status",
          label: this.$t("Status")
        },
        {
          type: "remove",
          label: this.$t("Remove")
        }
      ],
      files: [],
      localUploadToken: null,
      totalUsed: 0,
      usageLimit: 1073741824,
      units: ["b", "kb", "mb", "gb"],
      isUploading: !1
    };
  },
  computed: {
    allowMultiple() {
      return this.options.allowMultiple !== !1;
    },
    getPercentage() {
      return (this.totalUsed / this.usageLimit * 100).toFixed(1);
    },
    buttonMessage() {
      return this.isUploading ? this.$t("Uploading...") : this.$t("Start Upload");
    },
    videoTypes() {
      return this.$t("3g2, 3gp, 3gp2, 3gpp, asf, avi, f4v, m4v, mkv, mov, mp4, mpeg, mpg, mts, qt, wmv");
    },
    imageTypes() {
      return this.$t("gif, jpg, jpeg, png");
    },
    audioTypes() {
      return this.$t("aac, ac3, mp3, ogg, wav, wma");
    },
    documentTypes() {
      return this.$t("ai, doc, docm, docx, dotm, dotx, pdf, potm, potx, pps, ppsm, ppsx, ppt, pptm, pptx, rtf, swf, txt, xls, xlsb, xlsm, xlsx, xltm, xltx");
    },
    uploadEnabled() {
      return this.hasValidFiles && !this.showError;
    },
    hasValidFiles() {
      return this.files.some((t) => !t.display.error);
    },
    showError() {
      return this.files.some((t) => t.display.error);
    },
    usageLimitString() {
      return this.$t("of %(amount)s used", {
        amount: this.getRoundedWithUnits(this.usageLimit, 1)
      });
    }
  },
  created() {
    this.options.initFiles && [...this.options.initFiles].forEach((t) => {
      const e = {
        file: t,
        display: {
          name: t.name,
          size: t.size,
          status: 0,
          error: !1
        }
      };
      this.files.push(e), this.totalUsed += t.size;
    });
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    getFirstSelectable() {
      const t = this.getFocusableElements();
      return t.length ? t[0] : this.$refs.focusTrap;
    },
    getFocusableElements() {
      return this.$refs.focusTrap.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    },
    handleClick() {
      this.$refs.fileInput.click();
    },
    hasError(t) {
      return t.display.error;
    },
    handleFileSelected(t) {
      const { files: e } = t.target;
      Array.from(e).forEach(async (o) => {
        const r = {
          file: o,
          display: {
            name: o.name,
            size: o.size,
            status: 0,
            error: !1
          }
        };
        this.files.push(r), this.totalUsed += o.size;
      });
    },
    removeItem(t) {
      this.files.splice(t, 1);
    },
    async getUploadUrl(t, e) {
      const { name: a, type: o } = t, r = await Be({
        baseURL: this.options.baseURL,
        folderId: this.options.folderGuid,
        filename: a,
        contentType: o,
        token: this.localUploadToken || this.options.uploadToken
      });
      if (r instanceof Error) {
        const i = this.files[e];
        return i.display.error = !0, null;
      }
      return r.data;
    },
    async uploadFile(t, e, a) {
      let o;
      try {
        o = await Ee({
          method: "post",
          url: t,
          data: e,
          headers: {
            "Content-Type": "multipart/form-data"
          },
          onUploadProgress: (r) => {
            const i = this.files[a];
            i.display.status = Math.round(r.loaded * 100 / r.total);
          }
        });
      } catch (r) {
        window.console.log("error: ", r);
      }
      return o;
    },
    async uploadFiles() {
      if (this.isUploading = !0, !this.localUploadToken && !this.options.uploadToken) {
        const a = await Ke({
          baseURL: this.options.baseURL
        });
        this.localUploadToken = a.tokens.upload;
      }
      const t = await Promise.all(this.files.map(async (a, o) => {
        const { file: r } = a, i = await this.getUploadUrl(r, o);
        if (i) {
          const { asset: n, fields: f, url: b } = i, u = new FormData();
          return Object.keys(f).forEach((w) => {
            u.append(w, f[w]);
          }), u.append("file", r), await this.uploadFile(b, u, o), n;
        }
        return null;
      }));
      this.isUploading = !1, t.some((a) => a) && this.$emit("assetsUploaded", t), this.showError ? this.files = this.files.filter((a) => a.display.error) : this.closeModal();
    },
    convertToKb(t) {
      return Math.ceil(t / 1e3);
    },
    getRoundedWithUnits(t, e) {
      if (!t)
        return `${t}${this.units[1]}`;
      const a = Math.floor(Math.log(t) / Math.log(1024));
      return `${(t / 1024 ** a).toFixed(e) * 1}${this.units[a]}`;
    }
  }
}, Tt = { class: "modal modal--base" }, kt = {
  class: "comet-modal js-comet-modal",
  ref: "focusTrap"
}, Nt = { class: "comet-modal__inner comet-modal--wide" }, Ct = { class: "comet-modal__header comet-long-form-text" }, Et = { class: "modal__heading" }, St = { class: "view" }, Dt = { class: "comet-modal__content comet-long-form-text" }, Ot = { class: "upload-modal" }, It = { class: "upload-modal__top-row" }, At = { class: "upload-modal__flex-group" }, Rt = {
  class: "comet-popover comet-popover--bottom",
  "aria-hidden": "true"
}, Mt = /* @__PURE__ */ c("div", { class: "comet-popover__nub" }, null, -1), Pt = /* @__PURE__ */ c("div", { class: "comet-popover__nub" }, null, -1), Ut = { class: "my-content--bold-text" }, Lt = ["innerHTML"], xt = { class: "my-content--bold-text" }, Bt = ["innerHTML"], Kt = { class: "my-content--bold-text" }, jt = ["innerHTML"], $t = { class: "my-content--bold-text" }, qt = ["innerHTML"], zt = { class: "upload-modal__actions" }, Vt = ["disabled"], Gt = { class: "comet-button__inner" }, Ht = { class: "comet-button__text" }, Wt = ["multiple", "disabled"], Yt = {
  class: "comet-data-table comet-sortable-table upload-modal-table upload-modal-table--header",
  "aria-hidden": "true"
}, Zt = { class: "comet-data-table__head" }, Qt = { class: "comet-data-table__row" }, Xt = { class: "sort__name" }, Jt = { class: "upload-modal__scroll-container" }, ea = { class: "comet-data-table comet-sortable-table upload-modal-table upload-modal-table--body" }, ta = { class: "comet-screenreader-only" }, aa = { class: "comet-data-table__head" }, oa = { class: "comet-data-table__row" }, na = { class: "sort__name" }, ra = ["data-label"], ia = {
  key: 0,
  class: "comet-data-table__error-container"
}, sa = {
  class: "comet-popover comet-popover--bottom",
  "aria-hidden": "true"
}, la = /* @__PURE__ */ c("div", { class: "comet-popover__nub" }, null, -1), ca = { key: 1 }, da = ["data-label"], ua = ["data-label"], fa = ["data-label"], ba = ["onClick", "aria-label", "disabled"], pa = { class: "comet-modal__footer upload-modal__footer" }, va = { class: "comet-modal__button-row" }, ma = ["disabled"], ha = ["disabled"];
function ya(t, e, a, o, r, i) {
  const n = Q("NebulaIcon"), f = Q("CometDropdown"), b = Q("focus-trap");
  return k(), N("div", null, [
    c("div", {
      class: "comet-modal-overlay js-comet-modal-overlay comet-modal-overlay--backdrop",
      role: "dialog",
      onClick: e[0] || (e[0] = (...u) => i.closeModal && i.closeModal(...u))
    }),
    c("div", Tt, [
      c("div", kt, [
        I(b, {
          active: "",
          "initial-focus": i.getFirstSelectable
        }, {
          default: j(() => [
            c("div", Nt, [
              c("div", Ct, [
                c("h3", Et, g(t.$t("Upload to My Content")), 1)
              ]),
              c("section", St, [
                c("div", Dt, [
                  c("section", Ot, [
                    c("div", It, [
                      c("div", At, [
                        c("p", null, g(t.$t("Add files to the upload queue and click the Start Upload button.")), 1),
                        I(f, {
                          "aria-label": t.$t("Permitted File Types"),
                          buttonId: "file-type-info",
                          buttonClass: `comet-button--dark comet-button--icon-only
                                                       comet-button--flat comet-button--dark upload-modal__info-button`,
                          dropdownClass: "comet-popover comet-popover--bottom upload-modal__dropdown",
                          isInModal: ""
                        }, {
                          button: j(() => [
                            I(n, {
                              class: "comet-button__icon comet-button__icon--left",
                              symbolId: "information",
                              size: "m"
                            }),
                            c("div", Rt, [
                              Mt,
                              de(" " + g(t.$t("Permitted File Types")), 1)
                            ])
                          ]),
                          items: j(() => [
                            Pt,
                            c("p", null, [
                              c("span", Ut, g(t.$t("Videos:")), 1),
                              c("span", { innerHTML: i.videoTypes }, null, 8, Lt)
                            ]),
                            c("p", null, [
                              c("span", xt, g(t.$t("Images:")), 1),
                              c("span", { innerHTML: i.imageTypes }, null, 8, Bt)
                            ]),
                            c("p", null, [
                              c("span", Kt, g(t.$t("Audio:")), 1),
                              c("span", { innerHTML: i.audioTypes }, null, 8, jt)
                            ]),
                            c("p", null, [
                              c("span", $t, g(t.$t("Documents:")), 1),
                              c("span", { innerHTML: i.documentTypes }, null, 8, qt)
                            ])
                          ]),
                          _: 1
                        }, 8, ["aria-label"])
                      ]),
                      c("div", zt, [
                        c("button", {
                          class: S(["comet-button comet-button--primary comet-button--icon-with-text comet-button--small", !i.allowMultiple && r.files.length && "comet-button--disabled"]),
                          onClick: e[1] || (e[1] = (...u) => i.handleClick && i.handleClick(...u)),
                          disabled: !i.allowMultiple && r.files.length || void 0
                        }, [
                          c("span", Gt, [
                            I(n, {
                              class: "comet-button__icon comet-button__icon--left",
                              symbolId: "plus",
                              size: "s"
                            }),
                            c("span", Ht, g(t.$t("Add File")), 1)
                          ])
                        ], 10, Vt),
                        c("input", {
                          type: "file",
                          style: { display: "none" },
                          ref: "fileInput",
                          multiple: i.allowMultiple || void 0,
                          onChange: e[2] || (e[2] = (...u) => i.handleFileSelected && i.handleFileSelected(...u)),
                          disabled: !i.allowMultiple && r.files.length || void 0
                        }, null, 40, Wt)
                      ])
                    ]),
                    c("div", {
                      class: S(["upload-modal__browse", r.files.length && "upload-modal__browse--contains-table"])
                    }, [
                      r.files.length ? (k(), N($, { key: 0 }, [
                        c("table", Yt, [
                          c("thead", Zt, [
                            c("tr", Qt, [
                              (k(!0), N($, null, X(r.headers, (u) => (k(), N("th", {
                                key: u.type,
                                scope: "col",
                                class: S(["comet-data-table__header table__header", `table__header--${u.type}`])
                              }, [
                                c("span", Xt, g(u.label), 1)
                              ], 2))), 128))
                            ])
                          ])
                        ]),
                        c("div", null, [
                          c("div", Jt, [
                            c("table", ea, [
                              c("caption", ta, g(t.$t("Upload Queue")), 1),
                              c("thead", aa, [
                                c("tr", oa, [
                                  (k(!0), N($, null, X(r.headers, (u) => (k(), N("th", {
                                    key: u.type,
                                    scope: "col",
                                    class: S(["comet-data-table__header table__header", `table__header--${u.type}`])
                                  }, [
                                    c("span", na, g(u.label), 1)
                                  ], 2))), 128))
                                ])
                              ]),
                              c("tbody", null, [
                                (k(!0), N($, null, X(r.files, (u, w) => (k(), N("tr", {
                                  key: u.name,
                                  class: S(["comet-data-table__row", i.hasError(u) && "comet-data-table__row--errored"])
                                }, [
                                  c("td", {
                                    class: "comet-data-table__cell table__cell table__cell--file-name",
                                    "data-label": t.$t("Filename")
                                  }, [
                                    i.hasError(u) ? (k(), N("div", ia, [
                                      I(f, {
                                        "aria-label": t.$t("This file format is not supported, please remove."),
                                        buttonId: "unsupported-format",
                                        buttonClass: `comet-button--dark comet-button--icon-only
                                                                                comet-button--flat comet-button--dark upload-modal__info-button`,
                                        dropdownClass: "comet-popover comet-popover--bottom upload-modal__dropdown",
                                        isInModal: "",
                                        buttonDisabled: ""
                                      }, {
                                        button: j(() => [
                                          I(n, {
                                            class: "comet-button__icon comet-button__icon--left",
                                            symbolId: "information",
                                            size: "m"
                                          }),
                                          c("div", sa, [
                                            la,
                                            de(" " + g(t.$t("This file format is not supported, please remove.")), 1)
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["aria-label"]),
                                      c("span", null, g(u.display.name), 1)
                                    ])) : (k(), N("span", ca, g(u.display.name), 1))
                                  ], 8, ra),
                                  c("td", {
                                    class: "comet-data-table__cell table__cell table__cell--size",
                                    "data-label": t.$t("Size")
                                  }, g(i.getRoundedWithUnits(u.display.size, 0)), 9, da),
                                  c("td", {
                                    class: "comet-data-table__cell table__cell table__cell--status",
                                    "data-label": t.$t("Status")
                                  }, g(u.display.status) + "% ", 9, ua),
                                  c("td", {
                                    class: "comet-data-table__cell table__cell table__cell--remove",
                                    "data-label": t.$t("Remove")
                                  }, [
                                    c("button", {
                                      class: "comet-button comet-button--danger comet-button--remove",
                                      onClick: (F) => i.removeItem(w),
                                      "aria-label": t.$t("remove file"),
                                      disabled: r.isUploading
                                    }, [
                                      I(n, {
                                        class: "comet-button__icon comet-button__icon--left",
                                        symbolId: "x",
                                        size: "s"
                                      })
                                    ], 8, ba)
                                  ], 8, fa)
                                ], 2))), 128))
                              ])
                            ])
                          ])
                        ])
                      ], 64)) : xe("", !0)
                    ], 2)
                  ])
                ]),
                c("div", pa, [
                  c("div", va, [
                    c("button", {
                      onClick: e[3] || (e[3] = (...u) => i.closeModal && i.closeModal(...u)),
                      class: "comet-button comet-button--ghost comet-modal__button comet-modal__button--cancel",
                      disabled: r.isUploading
                    }, g(t.$t("Close")), 9, ma),
                    c("button", {
                      onClick: e[4] || (e[4] = (...u) => i.uploadFiles && i.uploadFiles(...u)),
                      class: S(["comet-button comet-button--primary comet-modal__button", (r.isUploading || !i.uploadEnabled) && "comet-button--disabled"]),
                      disabled: r.isUploading || !i.uploadEnabled
                    }, g(i.buttonMessage), 11, ha)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["initial-focus"])
      ], 512)
    ])
  ]);
}
const ka = /* @__PURE__ */ he(Ft, [["render", ya]]);
export {
  ka as default
};
